<template>
    <div class="widget">
        <h2 class="title" v-if="period=='currentMonth'">Mois courant</h2>
        <h2 class="title" v-if="period!='currentMonth'">Total</h2>
        <div class="showbox" v-if="!count">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
            </div>
        </div>
        <div class="widget-content" v-if="count">
            <div class="widget-content-datas">
                <div>
                    <i class="icon icon-icon_layers"></i>
                    <div class="data-label"><span>Total des commandes</span>{{ count }}</div>
                </div>
                <div>
                    <i class="icon icon-icon_layers"></i>
                    <div class="data-label"><span>Total des ventes en CHF</span>{{ total }}</div>
                </div>
            </div>
        </div>
        <div class="buttons">
            <router-link to="/order"><span>Voir la liste</span></router-link>
        </div>
    </div>
</template>
<script>

    import OrderService from './OrderService.js';
    import Spline from '../../../components/chart/Spline.vue'

    export default {
        name: 'Widget',
        props: ['period'],
        components: {
            'spline' : Spline
        },
        data () {
            return {
                stats: {
                    dataset: null,
                    labels: null
                },
                count: null,
                total: null
            }
        },
        mounted: function(){
            OrderService.getStatsDetail().then((response) => {
                this.count = response.data.result.count
                this.total = response.data.result.total
            }).catch((response) => {
                console.log("error", response);
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/order/OrderWidget.vue